import { render, staticRenderFns } from "./child.vue?vue&type=template&id=4aa431be"
import script from "./child.vue?vue&type=script&lang=js"
export * from "./child.vue?vue&type=script&lang=js"
import style0 from "./child.vue?vue&type=style&index=0&id=4aa431be&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports